import React from 'react';
import { Button } from '@grubhubprod/gh-cookbook-react';
import { useHistory } from 'react-router-dom';
import { useDeactivateEmployee } from 'src/components/common/hooks/useDeactivateEmployee/useDeactivateEmployee';
import { ConfirmDialog } from 'src/components/enterprise/features/Employee/components/ConfirmDialog/ConfirmDialog';
import { pushError } from 'src/utilities/notifications/errorHandling';
import { getWindow } from 'src/utilities/window';
import {
  buildCAUIUrl,
  buildCMUIPath,
  CAUIPage,
  CMUIPage,
} from 'src/constants/urls';
import { useEmployeeListFeatureAccess } from 'src/components/enterprise/features/Employee/Routes/useEmployeeListFeatureAccess/useEmployeeListFeatureAccess';

export interface DeactivateEmployeeWrapperProps {
  corpId: string;
  employeeId: string;
}

export const DeactivateEmployeeWrapper: React.FC<DeactivateEmployeeWrapperProps> =
  ({ corpId, employeeId }) => {
    const { canAccessEmployeeList } = useEmployeeListFeatureAccess();
    const { push } = useHistory();

    const handleSuccess = async (): Promise<void> => {
      if (canAccessEmployeeList) {
        push(buildCMUIPath(CMUIPage.EMPLOYEES, { corpId }));
      } else {
        const window = getWindow();
        window.location.href = buildCAUIUrl(CAUIPage.EMPLOYEES, { corpId });
      }
    };

    const handleError = async (): Promise<void> => {
      pushError('Employee was not deactivated. Try again.');
    };

    const { deactivateEmployee, isLoading } = useDeactivateEmployee({
      corpId,
      employeeId,
      onSuccess: handleSuccess,
      onError: handleError,
    });

    return (
      <ConfirmDialog
        title="Deactivate Employee"
        description="Deactivating an employee will permanently remove them. Are you sure you want to do this?"
        confirmLabel="Deactivate"
        isLoading={isLoading}
        onConfirm={deactivateEmployee}
      >
        <Button variant="tertiary" buttonSize="medium">
          Deactivate
        </Button>
      </ConfirmDialog>
    );
  };
